import React from 'react';

import HWNavBar from '../_HWNavBar';

function Week10HWPlaceHolder() {
  return (
    <div className="app-container">
      <HWNavBar />
      <div className="content">Week10HWPlaceHolder</div>;
    </div>
  );
}

export default Week10HWPlaceHolder;
